import { MapData } from '@/features/orders/components/MapPanel/parts/Content/types'
import { useEffect, useState } from 'react'

export const useMapDataSnapshot = (liveData: MapData, paused: boolean) => {
    const [dataSnapshot, setDataSnapshot] = useState<MapData>()

    useEffect(
        function syncDataSnapshot() {
            if (paused) return

            const hasMapPoints = Boolean(liveData.venue || liveData.orders.length)
            // Ignore empty data only until the first displayable snapshot.
            setDataSnapshot((current) => (current || hasMapPoints ? liveData : current))
        },
        [liveData, paused]
    )

    return dataSnapshot
}
